import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthRedirectComponent} from './components/auth-redirect/auth-redirect.component';
import {DsabRedirectComponent} from './routing/dsab-redirect.component';

const routes: Routes = [
  {
    path: 'backend',
    loadChildren: () => import('./modules/backend/backend.routes').then(m => m.BACKEND_ROUTES)
  },
  {
    path: 'frontend',
    loadChildren: () =>
      import('./modules/frontend/frontend.routes').then(m => m.FRONTEND_ROUTES)
  },
  {
    path: 'web',
    loadChildren: () =>
      import('./modules/website/website.routes').then(m => m.WEBSITE_ROUTES)
  },
  {
    path: 'authredirect',
    component: AuthRedirectComponent
  },
  {
    path: '',
    redirectTo: '/frontend/events',
    pathMatch: 'full'
  },

  // Direkt-Links für besondere Kunden
  {
    path: 'dsab',
    component: DsabRedirectComponent
  },
  {
    path: 'm/:database/:mandantKey',
    redirectTo: '/frontend/events/:database/mandant/:mandantKey'
  },
  {
    path: 'loewen',
    redirectTo: '/frontend/order?loewen=1'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule
{
}
